'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var ConfigurationParametersTransformerFactory = function ConfigurationParametersTransformerFactory($log, DataTransformer, configurationParametersControlTypeService, configurationParametersRenderersFactory) {
  function assignCustomControlType(row) {
    if (configurationParametersControlTypeService.isControlTypeMultiSelectDropdown(row.propertyName)) {
      row.customControlType = 'multidropdownlist';
    } else if (configurationParametersControlTypeService.isControlTypeDropdown(row.propertyName)) {
      row.customControlType = 'dropdownlist';
    } else if (configurationParametersControlTypeService.isControlTypeMaskedInput(row.propertyName)) {
      row.customControlType = 'maskedinput';
      row.customControlMask = configurationParametersControlTypeService.getMask(row.propertyName);
      row.customControlMaskFunc = configurationParametersRenderersFactory.maskTimeValue;
    } else if (configurationParametersControlTypeService.isControlTypeDatetime(row.propertyName)) {
      row.customControlType = 'custom';
      row.dateRowParameters = configurationParametersControlTypeService.getDateRowsConfig(row.propertyName);
    }
  }
  function formatValue(key, value) {
    return configurationParametersRenderersFactory.formatValue(key, value);
  }
  function ConfigurationParametersTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-parameters-mode';
    this.priority = 1;
  }
  ConfigurationParametersTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationParametersTransformer.constructor = ConfigurationParametersTransformer;
  ConfigurationParametersTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationParametersTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationParametersTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationParametersTransformer.prototype.transform = function (data) {
    var properties;
    var result = [];
    properties = data.domain.properties;
    if (properties) {
      result = _.reduce(properties, function (acc, value, key) {
        if (configurationParametersControlTypeService.isValueVisible(key)) {
          var propertyRow = {
            propertyName: key,
            propertyValue: formatValue(key, value),
            propertyType: (0, _typeof2["default"])(value),
            isRowEditable: configurationParametersControlTypeService.isValueEditable(key)
          };
          assignCustomControlType(propertyRow);
          acc.push(propertyRow);
        }
        return acc;
      }, []);
    } else {
      $log.warn('ConfigurationParametersTransformer: incorrect data format from SimpleHEP');
    }
    return result;
  };
  return ConfigurationParametersTransformer;
};
ConfigurationParametersTransformerFactory.$inject = ['$log', 'DataTransformerFactory', 'ConfigurationParametersControlTypeService', 'ConfigurationParametersRenderersFactory'];
module.exports = ConfigurationParametersTransformerFactory;